import { useEffect } from 'react';
import { FieldValues, Path, UseFormClearErrors, UseFormSetError, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { IBusinessProfile } from '../../../../../../../Interfaces/responseTypes';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import { getOrderTimeValidationMessageKey, isBusinessFreeDay } from '../../../../../../../Utilits/utilits';

interface IUseOrderScheduleValidationProps<T extends FieldValues> {
  business_profile?: IBusinessProfile | null;
  watch: UseFormWatch<T>;
  setValue: UseFormSetValue<T>;
  setError: UseFormSetError<T>;
  clearErrors: UseFormClearErrors<T>;
}

const useOrderScheduleValidation = <T extends FieldValues>({
  business_profile,
  watch,
  setValue,
  setError,
  clearErrors,
}: IUseOrderScheduleValidationProps<T>) => {
  const { t } = useLanguagesHooks();
  const selectedDate = watch('date' as Path<T>);

  useEffect(() => {
    if (!business_profile || !selectedDate) {
      return;
    }

    if (isBusinessFreeDay(String(selectedDate), business_profile.free_days)) {
      setError('date' as Path<T>, {
        message: t(getOrderTimeValidationMessageKey('closed_day')),
      });
      setValue('time' as Path<T>, undefined as never);
      return;
    }

    clearErrors('date' as Path<T>);
  }, [business_profile, clearErrors, selectedDate, setError, setValue, t]);
};

export default useOrderScheduleValidation;
